import {Component} from 'react';
import CareerCard from './career_card';
import {SingleSelectionContext} from '../../objects/Context/single_selection_context';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import {calcInflationAmt} from '../../objects/CommonUse/calc_inflation_amt';
import WaitTimeSpinner from './wait_time_spinner';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';

class CareerInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rerender: false,
            loading: true,
            headers: setHeadersForFetch(),
            environment: Config.dataURL.currentEnv,
        };
        this.jobSelection = null;
        this.subProcess = "CareerInput";
        this.jobsArr = [];
        props.onOpen();
    }

    componentDidMount(){
        // render and return are done before it is mounted for the first time!!!
        this.getJobsList();
    }

    calcInflatedCost(){
        this.calcGameYears();
        var i;
        for (i=0; i< this.jobsArr.length; i++){
            this.jobsArr[i].minSalary = 
                +calcInflationAmt(this.jobsArr[i].minSalary, this.yearsDiff);
            this.jobsArr[i].maxSalary = 
                +calcInflationAmt(this.jobsArr[i].maxSalary, this.yearsDiff);
        }
        this.inflatedCostDoneSw = true;
    }  
       
    calcGameYears(){
        var yearMonthVals = [];
        yearMonthVals = this.props.currentGameDate.split('-'); 
        this.currentGameYear = +yearMonthVals[0];
        yearMonthVals = this.props.startGameDate.split('-'); 
        this.startGameYear = +yearMonthVals[0];
        this.yearsDiff = this.currentGameYear - this.startGameYear;
    }

    render() { 
        if (this.jobsArr.length !== 0 && this.props.currentGameDate 
            && this.inflatedCostDoneSw !== true){
                this.calcInflatedCost(); 
        }
        let selectedJob = sessionStorage.getItem("careerChoice");
        if (selectedJob) {
            this.jobSelection = selectedJob;
        }
        let careerList = this.jobsArr.map((job, key) =>
            <CareerCard key={key} selectedJobID={this.jobSelection} jobProfile={job} 
                currentJobName={this.props.currentJobName}
                onSelected={() => this.onJobSelected({job})}/>
        );
          
    return <>
            <div className="col-sm-8 mt-1">
                <div className="card mt-3 mx-0 rounded-corners-lg text-center height-max">
                    <h3 className="mt-2">Choose a Job</h3>
                    <p>
                        The jobs below are common career choices in the United States. They're 
                        ranked by match score.  Jobs at the top are the closest fit to your 
                        skills and interests based on the survey you completed.     
                    </p>
                    {this.state.loading  || this.props.waitState ?
                       <WaitTimeSpinner />
                    :
                        <div className="mt-2 mb-5 overflow-scroll">
                            <SingleSelectionContext.Provider value={this.state}>
                                {careerList}
                            </SingleSelectionContext.Provider>
                        </div>
                    }
                </div>
            </div>
        </>
    }

    getJobsList() {
        const skillsInput = sessionStorage.getItem("skillsInterestsInput");
        const funcName = "jobsList";
        const urlParm = "?skills=" + skillsInput;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        // sort by match score and job name
                        this.jobsArr = output.body;
                        this.setState({loading: false});
                    }else{
                        const errorObj={function: funcName, subProcess: this.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
    }


    onJobSelected(job) {
        job = job.job;
        sessionStorage.setItem("careerChoice", job.id);
        sessionStorage.setItem("careerName", job.jobName);
        sessionStorage.setItem("salary", job.minSalary);
        sessionStorage.setItem("jobNbrYearsCollege", job.nbrYearsCollege);
        sessionStorage.setItem("jobDegreeType", job.degreeType);
        sessionStorage.setItem("jobDegreeSpecialty", job.degreeSpecialty);
        sessionStorage.setItem("jobHealthInsInd", job.healthInsPaidInd);
        sessionStorage.setItem("jobMatchScore", job.matchScore);
        sessionStorage.setItem("jobRank", job.rank);
        sessionStorage.setItem("careerPictureImg", job.pictureImg);
        sessionStorage.setItem("careerBackgroundImg", job.backgroundImg);
        sessionStorage.setItem("careerMaxSalary", job.maxSalary);
        sessionStorage.setItem("careerLevel2Title", job.level2Title);
        sessionStorage.setItem("careerLevel3Title", job.level3Title);
        var relatedCareers = [];
        if (job.relatedCareers){
                relatedCareers = job.relatedCareers      
        }
        sessionStorage.setItem("careerRelatedCareers", JSON.stringify(relatedCareers));
        this.jobSelection = job.id;
        this.setState({rerender: true});
        this.props.onSelected();  
        
    }
}
 
export default CareerInput;